// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__Rw8Bp","link":"Breadcrumbs_link__55rSX","current":"Breadcrumbs_current__Juv6i","separator":"Breadcrumbs_separator__pPWmV"};